import { getSupabaseClient } from './authenticated-client';

// Export the same singleton instance to prevent multiple clients
export const supabase = getSupabaseClient();

// If you have Supabase types generated (e.g., from `supabase gen types typescript > types.ts`),
// you might import them and use them like this:
// import { Database } from './types'; // Assuming types.ts exists in the same folder
// export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
